import { Button } from "@/components/ui/baseUi/button"
import { Input } from "@/components/ui/baseUi/input"
import { word } from "@modules/core/utils/i18n"
import { useState } from "react"

type NewChatGroupNameFormProps = {
  onValidate: (groupName: string) => void
  onCancel: () => void
  defaultGroupName?: string
}

export const NewChatGroupNameForm: React.FC<NewChatGroupNameFormProps> = ({
  onValidate,
  onCancel,
  defaultGroupName = "",
}) => {
  const [groupName, updateGroupName] = useState<string>(defaultGroupName)

  return (
    <div>
      <Input
        id={"groupName"}
        value={groupName}
        onChange={(e) => updateGroupName(e.currentTarget.value)}
        placeholder={word("chat.group_chat_name")}
      />

      <div className="mt-4 flex justify-end">
        <div className="column flex gap-3 sm:flex-row">
          <Button variant="outline" onClick={onCancel}>
            {word("chat.cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={() => onValidate(groupName)}
            disabled={!(groupName && groupName.length > 0)}
          >
            {word("chat.confirm")}
          </Button>
        </div>
      </div>
    </div>
  )
}
